import { Route, Routes, useParams, useSearchParams } from "react-router";

import type { BranchSteps } from "./branch-navigation";
import { BranchNavigation } from "./branch-navigation";
import { ProjectNavigation } from "./project-navigation";

function ParamProjectToolbar({
  branchStepOverrides,
}: {
  branchStepOverrides?: Partial<BranchSteps>;
}) {
  const params = useParams<{
    projectId: string;
    workspaceId?: string;
    executionId?: string;
  }>();
  const [searchParams] = useSearchParams();

  const workspaceId =
    params.workspaceId ?? searchParams.get("workspace") ?? undefined;

  return params.projectId ? (
    workspaceId ? (
      <BranchNavigation
        {...params}
        workspaceId={workspaceId}
        stepOverrides={branchStepOverrides}
      />
    ) : (
      <ProjectNavigation {...params} workspaceId={workspaceId} />
    )
  ) : null;
}

export function RoutedProjectToolbar() {
  const [searchParams] = useSearchParams();
  return (
    <Routes>
      <Route path="projects/:projectId">
        <Route path="workspaces/:workspaceId">
          <Route path="executions/:executionId">
            <Route index path="*" element={<ParamProjectToolbar />} />
          </Route>
          <Route index path="*" element={<ParamProjectToolbar />} />
        </Route>
        {/* Added this route to always have the search space unset when creating a new search space */}
        <Route
          path="search-spaces/new"
          element={
            <ParamProjectToolbar
              branchStepOverrides={{
                design: {
                  to: `./..${searchParams.toString() ? `?${searchParams.toString()}` : ""}`,
                },
                candidate: {},
              }}
            />
          }
        />
        <Route index path="*" element={<ParamProjectToolbar />} />
      </Route>
      {/* tests warn if no Route matches */}
      <Route index path="*" element={null} />
    </Routes>
  );
}
